import React, { useCallback } from 'react';

import styled from 'styled-components';

import { DocumentsSections } from '@cd3p/core/modules/documents';
import { APIDocument, APIUserType } from '@cd3p/core/types/api';
import { Stack, Typography } from 'components';

import { useSelector, useTranslation } from 'third-party';

import { appSelectors, helpCenterSelectors } from 'selectors';

import { DocsSectionsTree } from 'features/Docs/DocsSectionsTree';

const Content = styled(Stack)`
  padding: 0.8rem;
  gap: 0.8rem;
  flex: 1;
  overflow-y: scroll;
`;

const Title = styled(Typography)`
  font-size: 1.4rem;
  font-weight: 600;
  color: ${props => props.theme.custom.palette.bluegray500};
`;

export const DIALOG_ITEM_HEIGHT = 85;
export const CONTRACTOR_DIALOG_ITEM_HEIGHT = 65;

type AllHelpArticlesListProps = {
  onSelect: (data: APIDocument) => void;
};

export const AllHelpArticlesList = ({ onSelect }: AllHelpArticlesListProps) => {
  const { t } = useTranslation();
  const userType = useSelector(appSelectors.userType);
  const helpCenterItemsTree = useSelector(
    helpCenterSelectors.helpCenterItemsTree,
  );
  const helpCenterItemsLoading = useSelector(
    helpCenterSelectors.helpCenterItemsLoading,
  );
  const helpCenterItemsLoaded = useSelector(
    helpCenterSelectors.helpCenterItemsLoaded,
  );

  const onDocsTreeDocumentClick = useCallback(
    (document: APIDocument) => {
      onSelect(document);
    },
    [onSelect],
  );

  return (
    <Content>
      <Title variant="body2">{t('helpCenter.panel.allArticlesTitle')}</Title>
      <DocsSectionsTree
        isReadonly
        isLoading={helpCenterItemsLoading}
        isLoaded={helpCenterItemsLoaded}
        sectionId={
          userType === APIUserType.Contractor
            ? DocumentsSections.HelpCenterWebContractor
            : DocumentsSections.HelpCenterWebDispatcher
        }
        items={helpCenterItemsTree}
        onDocumentClick={onDocsTreeDocumentClick}
      />
    </Content>
  );
};
